var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const wrapThrowsAsync = (fn) => async (...args) => {
  try {
    return {
      ok: true,
      data: await fn(...args)
    };
  } catch (error) {
    return {
      ok: false,
      error
    };
  }
};
class MethodQueue {
  constructor() {
    __publicField(this, "queue", []);
    __publicField(this, "isExecuting", false);
    __publicField(this, "add", (method) => {
      this.queue.push(method);
      this.run();
    });
    __publicField(this, "runNext", async () => {
      if (this.isExecuting)
        return;
      const method = this.queue.shift();
      if (method) {
        this.isExecuting = true;
        try {
          await method();
        } finally {
          this.isExecuting = false;
          if (this.queue.length > 0) {
            this.runNext();
          }
        }
      }
    });
    __publicField(this, "run", async () => {
      if (!this.isExecuting && this.queue.length > 0) {
        await this.runNext();
      }
    });
    __publicField(this, "clear", () => {
      this.queue = [];
    });
  }
}
let isInitializing = false;
let isInitialized = false;
const methodQueue = new MethodQueue();
const loadFormbricksSDK = async (apiHost, sdkType) => {
  if (!window.formbricks) {
    const res = await fetch(`${apiHost}/api/packages/${sdkType}`);
    if (!res.ok) {
      return { ok: false, error: new Error(`Failed to load Formbricks ${sdkType} SDK`) };
    }
    const sdkScript = await res.text();
    const scriptTag = document.createElement("script");
    scriptTag.innerHTML = sdkScript;
    document.head.appendChild(scriptTag);
    const getFormbricks = async () => new Promise((resolve, reject) => {
      const checkInterval = setInterval(() => {
        if (window.formbricks) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(checkInterval);
        reject(new Error(`Formbricks ${sdkType} SDK loading timed out`));
      }, 1e4);
    });
    try {
      await getFormbricks();
      return { ok: true, data: void 0 };
    } catch (error) {
      return {
        ok: false,
        error: new Error(error.message ?? `Failed to load Formbricks ${sdkType} SDK`)
      };
    }
  }
  return { ok: true, data: void 0 };
};
const loadFormbricksToProxy = async (prop, sdkType, ...args) => {
  const executeMethod = async () => {
    try {
      return await window.formbricks[prop](...args);
    } catch (error) {
      console.error(`🧱 Formbricks - Global error: ${error}`);
      throw error;
    }
  };
  if (!isInitialized) {
    if (isInitializing) {
      methodQueue.add(executeMethod);
    } else {
      if (prop === "init") {
        isInitializing = true;
        const initialize = async () => {
          const { apiHost } = args[0];
          const loadSDKResult = await wrapThrowsAsync(loadFormbricksSDK)(apiHost, sdkType);
          if (!loadSDKResult.ok) {
            isInitializing = false;
            console.error(`🧱 Formbricks - Global error: ${loadSDKResult.error.message}`);
            return;
          }
          try {
            const result = await window.formbricks[prop](...args);
            isInitialized = true;
            isInitializing = false;
            return result;
          } catch (error) {
            isInitializing = false;
            console.error(`🧱 Formbricks - Global error: ${error}`);
            throw error;
          }
        };
        methodQueue.add(initialize);
      } else {
        console.error(
          "🧱 Formbricks - Global error: You need to call formbricks.init before calling any other method"
        );
        return;
      }
    }
  } else {
    if (window.formbricks && typeof window.formbricks[prop] !== "function") {
      console.error(
        `🧱 Formbricks - Global error: Formbricks ${sdkType} SDK does not support method ${String(prop)}`
      );
      return;
    }
    methodQueue.add(executeMethod);
    return;
  }
};
export {
  loadFormbricksToProxy as l
};
//# sourceMappingURL=loadFormbricks-DaeJP_pg.js.map
